import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { request } from '../api';
import Layout from '../components/Layout';

export default function SettlementQueue() {
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, Number(params.get('page')) || 1);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    setError('');
    request(`/settlement-queue?page=${page}`).then(result => {
      if (live) setData(result);
    }).catch(e => live && setError(e.message));
    return () => { live = false; };
  }, [page]);
  return <Layout title="Stock selection settlement" error={error}>
    <p>Administrators can settle any batch. Paid members can settle their own batches after the target market close.</p>
    {data && <>
      <div className="ss-table"><table>
        <thead><tr><th>First session</th><th>Horizon</th><th>Models</th><th>Target close (UTC)</th><th>Status</th><th>Action</th></tr></thead>
        <tbody>{data.data.map(batch => <tr key={batch.id}>
          <td>{String(batch.first_session).slice(0, 10)}</td><td>{batch.horizon}</td><td>{batch.model_count}</td>
          <td>{batch.target_close}</td><td>{Number(batch.ready) ? 'Ready to settle' : 'Awaiting market close'}</td>
          <td>{Number(batch.ready) ? <Link to={`/stock-selection/batches/${batch.id}/settlement`}>Settle batch</Link> : <Link to={`/stock-selection/predictions/${batch.prediction_id}`}>View prediction</Link>}</td>
        </tr>)}</tbody>
      </table></div>
      {!data.total && <p>No unsettled batches with model predictions.</p>}
      <button disabled={page <= 1} onClick={() => setParams({page: String(page - 1)})}>Previous</button>
      <span>Page {page}</span>
      <button disabled={page * data.page_size >= data.total} onClick={() => setParams({page: String(page + 1)})}>Next</button>
    </>}
  </Layout>;
}
